import * as stagesBasicCase from "../../../Stages/StagesCase";
import basicCaseInsuranceFields from "../modules/basicCaseInsuranceFields";
import { FormDefinition } from "../../../../types/ProductService/ProductService";
import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import { FamilyLawCase } from "../../../../types/Products/FamilyLaw/FamilyLawCase";

export const stageFormDefinition = (product: FamilyLawCase): ReturnType<FormDefinition<FamilyLawCase>> => {
  const fields: FormElementPropsWithoutProduct<FamilyLawCase>[] = [
    {
      type: "ValidatorSelect",
      path: `${product.productClassName}.client.gender`,
      isDisabled: ({ product }) => product.stage === stagesBasicCase.STAGE_COMPLETED,
      options: () => [{ value: "male" }, { value: "female" }, { value: "diverse" }],
    },
    {
      type: "ValidatorTextField",
      path: `${product.productClassName}.client.givenName`,
      isDisabled: ({ product }) => product.stage === stagesBasicCase.STAGE_COMPLETED,
    },
    {
      type: "ValidatorTextField",
      path: `${product.productClassName}.client.familyName`,
      isDisabled: ({ product }) => product.stage === stagesBasicCase.STAGE_COMPLETED,
    },
    {
      type: "ExpandableTextField",
      path: `${product.productClassName}.personalTextMessage`,
      isDisabled: () => true,
      isHidden: ({ product }) => product.stage < stagesBasicCase.STAGE_DATA_COMPLETED,
      additionalProps: {
        multiline: true,
      },
    },
    ...basicCaseInsuranceFields({
      path: `${product.productClassName}.caseInsurance`,
      product: product,
      isHidden: ({ product }) => product.stage < stagesBasicCase.STAGE_DATA_COMPLETED,
    }),
  ];
  return {
    [stagesBasicCase.STAGE_CREATED]: fields,
    [stagesBasicCase.STAGE_DATA_COMPLETED]: fields,
    [stagesBasicCase.STAGE_CHECKED]: fields,
    [stagesBasicCase.STAGE_IN_PROGRESS]: fields,
    [stagesBasicCase.STAGE_COMPLETED]: fields,
  };
};
